import { useTranslation } from 'react-i18next';

import DateRanges from '@app/dashboard/components/inner_layout/DateRanges';
import type { IHeaderProps } from '@app/dashboard/types/innerLayout/balance_and_transfers/transfers/header';
import { useLangStore } from '@app/dashboard/store/lang';

import styles from './header.module.scss';

const Header = ({
  appliedRanges,
  handleRangesChange,
  isTransfersLoading,
}: IHeaderProps) => {
  const { t } = useTranslation();
  const { lang } = useLangStore();

  return (
    <header className={styles['header']}>
      <h1 className={styles['header__title']}>
        {t('innerLayout.balanceTransfers.transfers.title')}
      </h1>
      <DateRanges
        appliedRanges={appliedRanges}
        handleRangesChange={handleRangesChange}
        lang={lang}
        disabled={isTransfersLoading}
      />
    </header>
  );
};

export default Header;
